/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class VulnerabilitiesBySeverityByAccountWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("VulnerabilitiesBySeverityByAccountWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return VulnerabilitiesBySeverityByAccountWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<VulnerabilitiesBySeverityByAccountWidgetConfiguration>): VulnerabilitiesBySeverityByAccountWidgetConfiguration {
        let obj = Object.assign(new VulnerabilitiesBySeverityByAccountWidgetConfiguration(), model);
        VulnerabilitiesBySeverityByAccountWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<VulnerabilitiesBySeverityByAccountWidgetConfiguration>): VulnerabilitiesBySeverityByAccountWidgetConfiguration {
        if (!model) return null;
        return VulnerabilitiesBySeverityByAccountWidgetConfiguration.newInstance(<VulnerabilitiesBySeverityByAccountWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: VulnerabilitiesBySeverityByAccountWidgetConfiguration) {
        if (!obj) return;

        models.VulnerabilitiesBySeverityByAccountWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: VulnerabilitiesBySeverityByAccountWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, VulnerabilitiesBySeverityByAccountWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
